import { ApiPermissionType } from 'src/Libs/api/types'

const permissionKeys = ['permissionType', 'storagePermissionType', 'endUserPermissionType', 'eMobilityPermissionType'] as const

type PermissionKey = (typeof permissionKeys)[number]
// Oursource the call of the underlying permissionType, to make the function reuseable for the list- and simple-DTOs
type PermissionAccessor = (permissionType: PermissionKey) => ApiPermissionType | undefined

/**
 * Determines the most restrictive permission across all permission types.
 *
 * This function evaluates permission types in order of restrictiveness:
 * - 'no-access' is the most restrictive and takes precedence
 * - 'ro' (read-only) is more restrictive than 'rw' (read-write)
 * - If no permissions are found, returns undefined
 *
 * @param getPermission - Function that retrieves a permission value for a given permission type
 * @returns The most restrictive permission type, or undefined if no permissions are available
 */
export const restrictAccountLinkPermission = (getPermission: PermissionAccessor): ApiPermissionType | undefined => {
  let permission: ApiPermissionType | '' = ''

  for (const permissionType of permissionKeys) {
    const currentPermission = getPermission(permissionType)
    if (!currentPermission) {
      continue
    }

    if (currentPermission === ApiPermissionType.noAccess) {
      return currentPermission
    }

    if ((currentPermission === ApiPermissionType.rw && permission === '') || currentPermission === ApiPermissionType.ro) {
      permission = currentPermission
    }
  }

  return permission || undefined
}
